import { Component, EventEmitter, Input, Output } from '@angular/core';

export const extractBooleanValue = (data: boolean | Event): boolean => {
  if (typeof data === 'boolean') {
    return data;
  } else if (data instanceof Event) {
    return primitiveToBoolean(data.target['value']);
  }
  return false;
};

function primitiveToBoolean(value: string): boolean {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true' || !!+value;
  }

  return !value;
}

@Component({
  selector: 'custom-checkbox',
  templateUrl: 'custom_check-box.component.html'
})
export class CustomCheckBoxComponent {
  @Input()
  checkBoxMessage: string;
  @Input()
  id: string;
  @Input()
  @Output()
  name: string;
  @Input()
  value = false;
  @Output()
  change = new EventEmitter<boolean>();

  onChange(value: boolean) {
    this.change.emit(value);
  }
}
